import request from '@/utils/request'

export async function appletQR (param, lang) {
    return request({
        url: `/pc/api/qrcode${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function testLogin (param, lang) {
    return request({
        url: `/pc/api/checkLogin${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function classifyList (param, lang) {
    return request({
        url: `/pc/api/main/classes${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function reportList (param, lang) {
    return request({
        url: `/pc/api/main/products${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function subjectList (param, lang) {
    return request({
        url: `/pc/api/main/specialSubjects${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function reportDetail (param, lang) {
    return request({
        url: `/pc/api/main/product/detail${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function carouselList (param, lang) {
    return request({
        url: `/pc/api/main/slide/${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function singleDetail (param, lang) {
    return request({
        url: `/pc/api/main/news/detail${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function singleNewList (param, lang) {
    return request({
        url: `/pc/api/main/news${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function createVipOrder (param, lang) {
    return request({
        url: `/pc/api/main/product/vipOrderCreate${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function createOrder (param, lang) {
    return request({
        url: `/pc/api/main/product/createOrder${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function payPalDefray (param, lang) {
    return request({
        url: `/pc/api/main/paypal${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function payPalCheck (param, lang) {
    return request({
        url: `/pc/api/main/product/paypalPayCheckOrder${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function orderDetail (param, lang) {
    return request({
        url: `/pc/api/main/product/orderInfo${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function createPayQrCode (param, lang) {
    return request({
        url: `/pc/api/main/pay${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function memberLevelList (param, lang) {
    return request({
        url: `/pc/api/main/userLevelLists${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function getVipExamine (param, lang) {
    return request({
        url: `/pc/api/main/studentExamine${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function regionList (lang) {
    return request({
        url: `/areas${ lang ? '?lang=en' : '' }`,
        method: 'get'
    });
}

export async function vipExamine (param, lang) {
    return request({
        url: `/pc/api/main/applyForStudent${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function initConfig (param, lang) {
    return request({
        url: `/pc/api/main/init${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function userInfo (param, lang) {
    return request({
        url: `/pc/api/main/user/infos${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function reportPdf (param, lang) {
    return request({
        url: `/pc/api/main/product/privatePreView${ lang ? '?lang=en' : '' }`,
        method: 'get',
        responseType: 'blob',
        params: param
    });
}

export async function loginSystem (param, lang) {
    return request({
        url: `/pc/api/login${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function logoutSystem (lang, token) {
    return request({
        url: `/pc/api/main/user/logout${ lang ? '?lang=en' : '' }`,
        headers: token ? { Authorization: 'Bearer ' + token, isToken: false } : {},
        method: 'get'
    });
}

export async function registerSystem (param, lang) {
    return request({
        url: `/pc/api/email/register${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function sendRegisterCode (param, lang) {
    return request({
        url: `/pc/api/email/send_register_email_code${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function forgotPassword (param, lang) {
    return request({
        url: `/pc/api/email/reset_password${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function sendForgotCode (param, lang) {
    return request({
        url: `/pc/api/email/send_reset_password_email_code${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function autoLogin (param, lang) {
    return request({
        url: `/pc/api/autoCheck${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function userSubscribe (lang) {
    return request({
        url: `/pc/api/main/getSubscribeInfo${ lang ? '?lang=en' : '' }`,
        method: 'get'
    });
}

export async function emailSubscribe (param, lang) {
    return request({
        url: `/pc/api/main/subscribe${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function unsubscribe (param, lang) {
    return request({
        url: `/pc/api/main/unsubscribe${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function activityClassList (param, lang) {
    return request({
        url: `/pc/api/main/activity/classes${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function activityList (param, lang) {
    return request({
        url: `/pc/api/main/activity/lists${ lang ? '?lang=en' : '' }`,
        method: 'get',
        params: param
    });
}

export async function singleActivity (id, lang) {
    return request({
        url: `/pc/api/main/activity/${id}${ lang ? '?lang=en' : '' }`,
        method: 'get'
    });
}

export async function entryActivity (param, lang) {
    return request({
        url: `/pc/api/main/activity/reservation${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function activityMobileRegs (lang) {
    return request({
        url: `/pc/api/main/activity/regs${ lang ? '?lang=en' : '' }`,
        method: 'get',
    });
}

export async function sendInstitutionApplicationCode (param, lang) {
    return request({
        url: `/pc/api/institutionApplication/sendEmailCode${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function verifyInstitutionApplicationCode (param, lang) {
    return request({
        url: `/pc/api/institutionApplication/verifyEmailCode${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export async function institutionApplicationRegions (lang) {
    return request({
        url: `/pc/api/institutionApplication/regions${ lang ? '?lang=en' : '' }`,
        method: 'get'
    });
}

export async function institutionApplicationTypes (lang) {
    return request({
        url: `/pc/api/institutionApplication/institution-types${ lang ? '?lang=en' : '' }`,
        method: 'get'
    })
}

export async function currentInstitutionApplication (lang) {
    return request({
        url: `/pc/api/institutionApplication/current${ lang ? '?lang=en' : '' }`,
        method: 'get'
    })
}

export async function submitInstitutionApplication (param, lang) {
    return request({
        url: `/pc/api/institutionApplication${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export function changePcPassword(data, english) {
    return request({ url: `/pc/api/main/user/changePassword${english ? '?lang=en' : ''}`, method: 'post', data });
}

// 机构申请邮箱统一预检，不发送验证码。
export async function validateInstitutionApplicationEmail (param, lang) {
    return request({
        url: `/pc/api/institutionApplication/validateEmail${ lang ? '?lang=en' : '' }`,
        method: 'post',
        data: param
    });
}

export function searchInstitutionCompanies (keyword, english) {
    return request({
        url: '/pc/api/institutionApplication/companies',
        method: 'get',
        params: { keyword, ...(english ? { lang: 'en' } : {}) }
    })
}
